import React from 'react';
const CloneIcon = (props) => {
  return (
            <svg style={props.newStyle} className="cursor" onClick={props.handleClick} xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox={props.coords ? props.coords : "0 0 33 33"}>
                <path id="clone-solid" d="M18.637,0a1.928,1.928,0,0,1,1.928,1.928V13.5a1.928,1.928,0,0,1-1.928,1.928H7.069A1.928,1.928,0,0,1,5.141,13.5V1.928A1.928,1.928,0,0,1,7.069,0H18.637M7.069,16.709A3.217,3.217,0,0,1,3.856,13.5V5.141H1.928A1.928,1.928,0,0,0,0,7.069V18.637a1.928,1.928,0,0,0,1.928,1.928H13.5a1.928,1.928,0,0,0,1.928-1.928V16.709Z" fill={props.color ? props.color : "#FF6D73"} />
            </svg>
  )
}

export default CloneIcon;